import { Client } from "../../clients/client";
import moment from "moment";

import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { MarketplaceStopSyncCreateForm } from "./forms/MarketplaceStopSyncCreateForm";
import { MarketplaceStopSyncSchedule } from "./models/MarketplaceStopSyncSchedule";

export class MarketplaceUseCase {
  constructor(private client: Client) {}

  public async createMarketplaceStopSync(form: MarketplaceStopSyncCreateForm) {
    return this.client.marketplaces.postMarketplaceScheduleTemporaryStopSyncStock(
      {
        shopId: form.shop?.id!,
        marketplaceName: form.marketplaceName,
        fromDate: form.isStartImmediately
          ? undefined
          : moment(form.fromDate!).toISOString(),
        untilDate: moment(form.untilDate!).toISOString()
      }
    );
  }

  public async getMarketplaceStopSyncs(
    form: PaginationForm
  ): Promise<Pagination<MarketplaceStopSyncSchedule>> {
    return this.client.marketplaces.getMarketplaceScheduleTemporaryStopSyncStock(
      {
        page: form && form.page,
        limit: form && form.perPage
      }
    );
  }
}
